import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class NavService {
  private defaultAfterLoginUrl = '/';
  private localStorageKey = 'afterLoginUrl';

  private afterCheckoutUrl = '/';

  constructor(private router: Router) {}

  setAfterLoginUrl(url: string): void {
    console.log('Setting after login URL:', url);
    if(url.trim().startsWith('/404')){
      console.log('SETTING 404 URL??????');
    }else{
      localStorage.setItem(this.localStorageKey, url);
    }
  }

  getAfterLoginUrl(): string | null {
    return localStorage.getItem(this.localStorageKey);
  }

  clearAfterLoginUrl(): void {
    localStorage.removeItem(this.localStorageKey);
  }

  navigateAfterLogin(): void {
    const targetUrl = this.getAfterLoginUrl() || this.defaultAfterLoginUrl;
    console.log('Navigating to:', targetUrl);
    this.router.navigateByUrl(targetUrl);
    this.clearAfterLoginUrl();
  }

  //after checkout

  setAfterCheckoutUrl(url: string): void {
    console.log('Setting after checkout URL:', url);
    this.afterCheckoutUrl = url;
  }
  navigateAfterCheckout(): void {
    this.router.navigateByUrl(this.afterCheckoutUrl);
    this.afterCheckoutUrl = '/';
  }

}
